// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd391ac0","453":"3bef7b19","732":"e4601e52","977":"dc0d521a"}[chunkId] + ".chunk.js";
};